export * from "./data-table";
export * from "./empty-state";
export * from "./followers-change";
export * from "./game-image";
export * from "./game-platforms";
export * from "./game-price";
export * from "./list-card";
export * from "./list-skeleton";

// ⚠️ Deliberately NOT re-exporting "./rank-history" here.
//
// That one line put ECharts in the first-load JS of EVERY route. The chain:
// app/layout.tsx renders <Header> → SearchInput → SearchResultsDropdown →
// GamesResultsSection → GameResultItem, which imports { GameImage } from this
// barrel. `export *` is not tree-shaken across the client-reference boundary,
// so the barrel dragged ./rank-history → ChartContainer → EChart →
// `import * as echarts` into the shared chunk — ~1.3 MB raw / ~350 KB gz
// shipped to /login, /_not-found and every list page, none of which draw a
// chart.
//
// Chart consumers already import from the sub-barrel ("@/components/shared/
// rank-history") or the concrete module, so nothing needs this re-export.
// Verified before removal: no file imports a rank-history symbol
// (ChartContainer, RangeSelector, useChartOptions, RANGE_OPTIONS,
// getEchartsWatermark, buildChartEventMarkers, …) from "@/components/shared".
// Keep it that way — re-adding the line silently re-ships ECharts everywhere.
